import { render, staticRenderFns } from "./DoctorListSelectAllAndNew.vue?vue&type=template&id=636b1737&scoped=true"
import script from "./DoctorListSelectAllAndNew.vue?vue&type=script&lang=js"
export * from "./DoctorListSelectAllAndNew.vue?vue&type=script&lang=js"
import style0 from "./DoctorListSelectAllAndNew.vue?vue&type=style&index=0&id=636b1737&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636b1737",
  null
  
)

export default component.exports